import React from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import './LoginPage.css';
import logo from './logo.png';

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="DocuAssist Logo" className="login-logo" />
        <h1>Welcome to DocuAssist</h1>
        <p>Please sign in with your Microsoft account to continue</p>
        <button onClick={handleLogin} className="login-button">
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
};

export default LoginPage; 